import * as Yup from "yup";

// Année minimale acceptée pour toutes les dates saisies dans l'application
export const MIN_YEAR = 2020;
// Première date acceptée (année strictement supérieure à MIN_YEAR)
export const MIN_DATE_STRING = `${MIN_YEAR + 1}-01-01`;
export const MIN_DATE = new Date(MIN_YEAR + 1, 0, 1);
export const INVALID_YEAR_MESSAGE = "L'année doit être valide.";

// Pour les dates "historiques" (naissance, arrivée, contrat...) qui peuvent légitimement être avant 2020
export const MIN_HISTORICAL_YEAR = 1900;

/**
 * Vrai si la valeur est vide (le champ obligatoire est géré par `required`)
 * ou si la date est valide avec une année strictement supérieure à MIN_YEAR.
 * Accepte une string "YYYY-MM-DD", un Date ou un timestamp.
 */
export const isYearValid = (value, minYear = MIN_YEAR) => {
    if (value === undefined || value === null || value === "") return true;
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return false;
    return date.getFullYear() > minYear;
};

// Même chose pour les dates historiques (année >= 1900)
export const isHistoricalYearValid = (value) =>
    isYearValid(value, MIN_HISTORICAL_YEAR - 1);

/**
 * Validateur pour react-hook-form : `rules={{ validate: validateYear }}`
 * Retourne true ou le message d'erreur.
 */
export const validateYear = (value) =>
    isYearValid(value) || INVALID_YEAR_MESSAGE;

export const validateHistoricalYear = (value) =>
    isHistoricalYearValid(value) || INVALID_YEAR_MESSAGE;

/**
 * Combine validateYear avec d'autres validateurs react-hook-form existants.
 * Usage : `validate: withYearValidation(existingValidateFn)`
 */
export const withYearValidation =
    (...validators) =>
    (value, formValues) => {
        const yearResult = validateYear(value);
        if (yearResult !== true) return yearResult;
        for (const validator of validators) {
            if (typeof validator !== "function") continue;
            const result = validator(value, formValues);
            if (result !== true && result !== undefined) return result;
        }
        return true;
    };

/**
 * Test Yup à chaîner : Yup.date().test(...yearTest())
 */
export const yearTest = () => [
    "year",
    INVALID_YEAR_MESSAGE,
    (value) => isYearValid(value),
];
export const historicalYearTest = () => [
    "year",
    INVALID_YEAR_MESSAGE,
    (value) => isHistoricalYearValid(value),
];

// Yup.date() prêt à l'emploi avec la validation d'année
export const yupDate = () => Yup.date().test(...yearTest());
